import clsx from "clsx";
import { createPortal } from "react-dom";
import { colors } from "../../ui/colors";
import { XIcon } from "../../ui/icons/x";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { removeBanner, type Banner, type BannerVariant } from "./slice";

const BannerList = () => {
    const banners: Banner[] = useAppSelector(state => state.banners.banners);
    const dispatch = useAppDispatch();

    const variantBackgroundStyles: Record<BannerVariant, string> = {
        success: 'bg-green-200',
        error: 'bg-red-200',
        warning: 'bg-orange-200',
    };

    const variantColorsStyles: Record<BannerVariant, string> = {
        success: 'green-800',
        error: 'red-800',
        warning: 'orange-800',
    };

    const colorMap = new Map<BannerVariant, string>([
        ['success', colors.green[700]],
        ['error', colors.red[700]],
        ['warning', colors.warning[700]],
    ])

    return createPortal(
        <div
            onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
            }}
            className="fixed flex flex-col gap-4 top-6 right-6 z-[200] px-6 lg:p-0 w-auto">
            {banners.map(banner => (
                <div key={banner.id} className={clsx(variantBackgroundStyles[banner.variant], "transition-all flex duration-[400ms] ease-out rounded-[12px] p-[24px] items-center justify-between shadow-md z-40 min-w-96 gap-8")}>
                    <span className={clsx(`text-text-md font-semibold text-${variantColorsStyles[banner.variant]}`)}>
                        {banner.message}
                    </span>
                    <div
                        onClick={(e) => {
                            e.stopPropagation()
                            dispatch(removeBanner(banner.id))
                        }}
                        className={clsx(`rounded-[50%] border-[1px] p-[2px] cursor-pointer border-${variantColorsStyles[banner.variant]}`)}
                    >
                        <XIcon color={colorMap.get(banner.variant)!} size={16} />
                    </div>
                </div>
            ))}
        </div>,
        document.body
    );
};

export default BannerList;

